<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }

  .ModirEdit {
    font-weight: bolder;
    font-style: italic;
    text-decoration: underline;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Letter Issuance Form</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0' && Selected_DataList_LetterRequestCustomer_Record.id == 0"
      (click)="openModal_Customer(templateCustomer,0)" class="btn btn-warning" style="margin-right: 5px;"> Search Customers
      <i class="fa fa-vcard"></i> </button>
    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomer(templateLetterRequestCustomer)" class="btn btn-danger"
      style="margin-right: 5px;"> Attach to Letter <i class="fa fa-vcard"></i> </button>

    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomerCopy(templateLetterRequestCustomerCopy)" class="btn btn-info"
      style="margin-right: 5px;"> Copy Outgoing Letter<i class="fa fa-copy"></i> </button>

    <br />
    <br />

    <div [hidden]="Data_Seleted_Customer.id==0">

      <form [formGroup]="AddNewLetter">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Request ID </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Letter Number </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Behfa Customer Code </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Customer Name (English) </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name_en}}" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> <button type="button" [hidden]="Letter_Form_Id>'0'"
                (click)="openModal_CustomerAddress(templateCustomerAddress)" class="btn btn-danger"
                style="margin-right: 5px;"> Customer Instrument Location Address </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Address.address}}" />
          </div>
        </div>
        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_subject_id==true}">
            <label for="exampleInputEmail1"> Letter Subject </label>
            <select class="custom-select" (change)="ReadData_Textletter()" formControlName="subject_id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_sex==true}">
            <label for="exampleInputEmail1"> Title Recipient </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">Ms.</option>
              <option value="1" selected>Mr.</option>
            </select>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_giver_name==true}">
            <label for="exampleInputEmail1"> Recipient Name </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">Enter the recipient name.</small>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_giver_semat==true}">
            <label for="exampleInputEmail1"> Recipient Position </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">Enter the recipient position.</small>
          </div>
        </div>
        <div class="row" *ngIf="!hiddenDetailAndPrice">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Attachment </label>
            <select class="custom-select" formControlName="peyvast">
              <option value="0">No</option>
              <option value="1" selected>Yes</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Referenced Letter Number </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">Enter the referenced letter number.</small>
          </div>
          <div class="form-group col-md-4" *ngIf="Letter_Form_Id==0">
            <label for="exampleInputEmail1"> Referenced Letter Date </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id>0">
            <label for="exampleInputEmail1"> Referenced Letter Date </label>
            <input formControlName="bazgashtBeNamehTarikh" disabled type="text" class="form-control"
              placeholder="Type here...">
          </div>



        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_takhfif==true}">
            <label for="exampleInputEmail1"> Discount Percentage </label>
            <div class="row">
              <div class="form-group col-md-8">
                <input maxlength="2" formControlName="takhfif" type="number" class="form-control"
                  placeholder="Type here...">
                <small *ngIf="!get_Form_takhfif().valid && get_Form_takhfif().touched"
                  class="form-text text-muted MyErrorRedColor">Enter the discount percentage.</small>
              </div>
              <div class="form-group col-md-4">
                <input value="%" disabled style="font-weight: bolder;" type="text" class="form-control">
              </div>
            </div>



          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_arsh_afzoodeh==true}">
            <label for="exampleInputEmail1"> Value Added Tax </label>
            <div class="row">
              <div class="form-group col-md-8">
                <input maxlength="2" formControlName="arsh_afzoodeh" type="number" class="form-control"
                  placeholder="Type here...">
                <small *ngIf="!get_Form_arsh_afzoodeh().valid && get_Form_arsh_afzoodeh().touched"
                  class="form-text text-muted MyErrorRedColor">Enter the value added tax.</small>
              </div>
              <div class="form-group col-md-4">
                <input value="%" disabled style="font-weight: bolder;" type="text" class="form-control">
              </div>
            </div>

          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_pishPardakht==true}">
            <label for="exampleInputEmail1"> Advance Payment (IRR) </label>
            <input formControlName="pishPardakht" (keyup)="pishPardakht_Change()" type="number" class="form-control"
              placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Advance Payment (in Words) </label>
            <input formControlName="pishPardakhtAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Expense Services (IRR) </label>
            <input formControlName="khadamat" (keyup)="khadamat_Change()" type="number" class="form-control"
              placeholder="Type here...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Service Cost (in Words) </label>
            <input formControlName="khadamatAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">
          <div class="form-group col-md-12" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_textletter_id==true}">
            <label for="exampleInputEmail1"> Text Letter </label>
            <select class="custom-select" formControlName="textletter_id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Textletter" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <h5 *ngIf="!hiddenDetailAndPrice"> Invoice Recipient </h5>

      <button type="button" *ngIf="Letter_Form_Id=='0' || Letter_Draft_Form_Id>0"
        (click)="openModal_Customer(templateCustomer,1)" class="btn btn-warning" style="margin-right: 5px;"> Search Customers
        <i class="fa fa-vcard"></i> </button>

      <button type="button" *ngIf="Letter_Form_Id=='0' || Letter_Draft_Form_Id>0" (click)="Remove_ReciveCustomer()"
        class="btn btn-danger" style="margin-right: 5px;"> Delete Customer <i class="fa fa-times-circle"></i> </button>
      <form *ngIf="!hiddenDetailAndPrice">
        <br />
        <br />
        <div class="row">

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_ReciveCustomer.name}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Description Invoice Recipient </label>
            <input type="text" class="form-control" placeholder="Type here..."
              [(ngModel)]="Data_Seleted_ReciveCustomer_Dsc" name="Data_Seleted_ReciveCustomer_Dsc" />
          </div>
        </div>
      </form>

      <br *ngIf="!hiddenDetailAndPrice" />
      <hr *ngIf="!hiddenDetailAndPrice" />
      <br *ngIf="!hiddenDetailAndPrice" />

      <div *ngIf="!hiddenDetailAndPrice">

        <h5> Letter Messages </h5>

        <br />

        <form *ngIf="canEditMainForm" [formGroup]="MailMessageForm" (submit)="MailMessageForm_Submit()">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Letter Message </label>
              <select class="custom-select" formControlName="mailmessage_id">
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_MailMessage" [value]="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>

          <button type="submit" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i>
            Add Message </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_MailMessage.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Letter Message</th>
                <th *ngIf="canEditMainForm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_MailMessage" [ngClass]="{'ModirEdit': item.del==true}">
                <td>{{FormAdded_MailMessage.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="MailMessageForm_Delete(FormAdded_MailMessage.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <br *ngIf="!hiddenDetailAndPrice" />
      <br *ngIf="!hiddenDetailAndPrice" />

      <div>

        <h5> Remarks </h5>

        <br />

        <form *ngIf="canEditMainForm">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Text Note : </label>
              <input [(ngModel)]="FormAdded_Dsc_Input" name="FormAdded_Dsc_Input" type="text" class="form-control"
                placeholder="Type here...">
            </div>
          </div>

          <button type="button" (click)="FormAdded_Dsc_Submit()" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Add Note </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_Dsc.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Letter Message</th>
                <th *ngIf="canEditMainForm">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_Dsc"
                [ngClass]="{'ModirEdit': FormAdded_Dsc_Modir[FormAdded_Dsc.indexOf(item)]==true}">
                <td>{{FormAdded_Dsc.indexOf(item)+1}}</td>
                <td>{{item}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="FormAdded_Dsc_Delete(FormAdded_Dsc.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <br />
      <br />

      <h5> Instruments </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4" *ngIf="Edit_Device_Form_Index==-1">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> Select Instrument <i class="fa  fa-simplybuilt"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-4" *ngIf="Edit_Device_Form_Index==-1">
            <label for="exampleInputEmail1"> Persian Title </label>
            <select class="custom-select" formControlName="device_id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Devicepersian" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Calibration Location </label>
            <select class="custom-select" formControlName="location">
              <option value="0">Select</option>
              <option value="1">Customer Site</option>
              <option value="2">Behineh Laboratory</option>
            </select>
          </div>
        </div>

        <div class="row">


          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Count</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">Enter the quantity.</small>
          </div>


          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Manager Adjustment (IRR)</label>
            <input formControlName="incRailModir" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_DeviceForm_incRailModir().valid && get_DeviceForm_incRailModir().touched"
              class="form-text text-muted MyErrorRedColor">Enter the manager adjustment percentage.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Validity Period </label>
            <select formControlName="Expiration" class="custom-select">
              <option value="0">Select</option>
              <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Description </label>
            <textarea formControlName="dscUser" class="form-control" placeholder="Type here..."></textarea>

          </div>

        </div>

        <div class="row" *ngIf="Data_Seleted_Device_Record.title">
          <br />
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #39409b; color: white;">
                <tr>
                  <th>#</th>
                  <th>Note</th>
                  <th>Unit Amount (IRR)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of DataList_Tariff">
                  <td>{{DataList_Tariff.indexOf(item)+1}}</td>
                  <td style="text-align: left;">{{item.dsc}}</td>
                  <td>{{item.tariff|number}}</td>
                  <td>
                    <label *ngIf="selected_Tariff_Record.id!=item.id" for="exampleInputEmail1"><button type="button"
                        (click)="set_Selected_Tariff(item)" class="btn btn-danger left"> Select </button> </label>
                    <p *ngIf="selected_Tariff_Record.id==item.id" style="color: red;">Note Selected</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>


        <div class="row">
          <br />
          <br />

          <button type="submit" [disabled]="!DeviceForm.valid" *ngIf="Edit_Device_Form_Index==-1"
            class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Instrument </button>
          <button type="submit" [disabled]="!DeviceForm.valid" *ngIf="Edit_Device_Form_Index>-1" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Instrument </button>
          <button *ngIf="Edit_Device_Form_Index>-1" type="button" (click)="Cancel_DeviceFormList()"
            class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel </button>
          <button type="button" *ngIf="Edit_Device_Form_Index==-1" (click)="Calc_DeviceFormListPriceTotal()"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-calculate"></i> Calculate Invoice </button>

        </div>


      </form>


      <br />
      <br />

      <div class="table-responsive" style="max-height: 700px;"
        *ngIf="DeviceFormList.length>0 && Edit_Device_Form_Index==-1">
        <button (click)="exportexcel()" type="button" class="btn btn-warning" style="margin-right: 5px;"><i
            class="fa   fa-file-excel-o"></i> Excel </button>
        <br />
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Calibration Location</th>
              <th>Count</th>
              <th>Validity Period</th>
              <th *ngIf="!hiddenDetailAndPrice">Manager Adjustment (Percent)</th>
              <th *ngIf="!hiddenDetailAndPrice">Manager Adjustment (IRR)</th>
              <th *ngIf="!hiddenDetailAndPrice">Unit Amount (IRR)</th>
              <th *ngIf="!hiddenDetailAndPrice">Total (IRR)</th>
              <th>Remarks</th>
              <th>Description</th>
              <th *ngIf="canEditMainForm">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceFormList" [ngClass]="{'ModirEdit': item.modirEdit==true}">
              <td>{{DeviceFormList.indexOf(item)+1}}</td>
              <td title="{{item.device_name_en}}">
                <span style="cursor: pointer;text-decoration: underline;">{{item.device_name}}</span>
              </td>

              <td>{{item.location_name === 'محل مشتری' ? 'Customer Site' : item.location_name === 'آزمایشگاه بهینه' ? 'Behineh Laboratory' : item.location_name}}</td>

              <td>
                <input *ngIf="canEditMainForm" (keyup)="Calc_DeviceFormListPriceTotal()" type="number"
                  [(ngModel)]="item.tedad" />
                <p *ngIf="!canEditMainForm">{{item.tedad}}</p>
              </td>

              <td>
                <select *ngIf="canEditMainForm" [(ngModel)]="item.expiration" class="custom-select">
                  <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
                </select>
                <p *ngIf="!canEditMainForm">{{item.expiration_title}}</p>
              </td>


              <td *ngIf="!hiddenDetailAndPrice">
                <input *ngIf="canEditMainForm" type="number" (keyup)="Calc_IncreaseModir(false,item)"
                  [(ngModel)]="item.incPercentModir" />
                <p *ngIf="!canEditMainForm">{{item.incPercentModir|number}}</p>
              </td>
              <td *ngIf="!hiddenDetailAndPrice">
                <input *ngIf="canEditMainForm" type="number" (keyup)="Calc_IncreaseModir(true,item)"
                  [(ngModel)]="item.incRailModir" />
                <p *ngIf="!canEditMainForm">{{item.incRailModir|number}}</p>
              </td>


              <td *ngIf="!hiddenDetailAndPrice">{{item.price|number}}</td>
              <td *ngIf="!hiddenDetailAndPrice">{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dscUser}}</td>

              <td *ngIf="canEditMainForm">
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=1" style="cursor: pointer;"
                        (click)="Device_upgrade_First(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-double-up"></i> First </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=1" style="cursor: pointer;"
                        (click)="Device_upgrade(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-up"></i> Up </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=DeviceFormList.length" style="cursor: pointer;"
                        (click)="Device_downgrade(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-down"></i> Down </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=DeviceFormList.length" style="cursor: pointer;"
                        (click)="Device_downgrade_Last(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-double-down"></i> Last </a>

                      <a style="cursor: pointer;" (click)="EditDeviceFormList(DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>

                      <a style="cursor: pointer;"
                        (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>

          </tbody>
          <tfoot style="position:sticky ;bottom: 0; background-color: #399b77;border: 1px solid #000;color: white;">
            <tr style="font-weight: bolder;text-decoration: underline;">

              <td colspan="4">
                Instruments at Behineh Laboratory
              </td>
              <td *ngIf="hiddenDetailAndPrice" colspan="2">
                Instruments at Behineh Laboratory
              </td>

              <td>
                {{DeviceCount_OutLocation|number}} items
              </td>
              <td>
                {{DevicePrice_OutLocation|number}} IRR
              </td>



              <td colspan="2">
                Instruments at the Customer Site
              </td>
              <td>
                {{DeviceCount_InLocation|number}} items
              </td>
              <td colspan="2">
                {{DevicePrice_InLocation|number}} IRR
              </td>

              <td *ngIf="canEditMainForm"></td>
            </tr>



            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                Total (IRR)
              </td>
              <td colspan="5">
                {{DeviceFormListPriceTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                Services (IRR)
              </td>
              <td colspan="5">
                {{DeviceFormListKhadamatTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                Discount (IRR)
              </td>
              <td colspan="5">
                {{DeviceFormListTakhfifTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                Value Added Tax (IRR)
              </td>
              <td colspan="5">
                {{DeviceFormListarsh_afzoodehTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                Final Amount (IRR)
              </td>
              <td colspan="5">
                {{DeviceFormListPriceTotalTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <br />
      <br />

      <div *ngIf="canEditPlannigForm || Schedule_DataList.length>0">

        <h5> Scheduling </h5>

        <br />

        <form [formGroup]="ScheduleForm" (submit)="ScheduleForm_Submit()">

          <input *ngIf="canEditPlannigForm" type="hidden" formControlName="id" />

          <div *ngIf="canEditPlannigForm" class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1"> Date </label>
              <input type="text" #datepickerInputEnd formControlName="persianDate" placeholder="Type here..."
                class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
                [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> Start Time </label>
              <select class="custom-select" formControlName="startHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> End Time </label>
              <select class="custom-select" formControlName="endHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>
            <div class="form-group col-md-3" style="display: none;">
              <label for="exampleInputEmail1"> Publish Approved Critical Comments </label>
              <select class="custom-select" formControlName="comment">
                <option value="1"> Yes </option>
                <option value="0"> No </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> Description </label>
              <textarea class="form-control" formControlName="dsc" placeholder="Type here...">
              </textarea>
            </div>

          </div>

          <button *ngIf="canEditPlannigForm" type="submit" [disabled]="!ScheduleForm.valid" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Date </button>

          <button type="button" *ngIf="!ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa  fa-eye"></i> View All Orders </button>

          <button type="button" *ngIf="ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-right: 5px;"><i class="fa  fa-eye-slash"></i> Hide Active Orders </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="Schedule_DataList.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Time</th>
                <th>Description</th>
                <th>Publish Comments</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of Schedule_DataList">
                <tr *ngIf="(ShowDelete_Schedule || item.del==false)">
                  <td>{{Schedule_DataList.indexOf(item)+1}}</td>
                  <td>{{item.persianDate}}</td>
                  <td>From {{item.startDate}} to {{item.endDate}}</td>
                  <td>{{item.dsc}}</td>
                  <td>
                    <p *ngIf="item.comment==1">Yes</p>
                    <p *ngIf="item.comment==0">No</p>
                  </td>
                  <td style="cursor: pointer;"
                    *ngIf="canEditPlannigForm && !canCheckingPlaningForm && item.status!=true && item.del==false ">

                    <button type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration,item)"
                      class="btn btn-danger" style="margin-right: 5px;"> Calibration Technician <i class="fa fa-user-circle-o"></i>
                    </button>

                    <button type="button" (click)="openModal_DeviceBehfa(templateDeviceBehfa,item)"
                      class="btn btn-warning left"> Equipment <i class="fa fa-building"></i> </button>


                    <a style="cursor: pointer;" (click)="ScheduleForm_Delete(Schedule_DataList.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                  <td style="cursor: pointer;" *ngIf="canCheckingPlaningForm && item.status!=true && item.del==false ">
                    <button type="button" (click)="openModal90(templateRequest90,1,item)" class="btn btn-success"
                      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Approve Schedule </button>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" class="btn btn-success"><i
                        class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                  <td style="cursor: pointer;" *ngIf="item.status==true && item.del==false ">
                    <p style="color: blue">Approve Schedule</p>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" class="btn btn-success"><i
                        class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>
                  <td style="cursor: pointer;"
                    *ngIf="!canEditPlannigForm && !canCheckingPlaningForm && item.status!=true && item.del==false">
                    <p style="color: orange">Under Review</p>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" style="margin-right: 5px;"
                      class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                    <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="Show_Activity_View(item)" type="button"
                      class="btn btn-warning" style="margin-right: 5px;"> <i class="fa fa-wpforms"></i> Assignment
                      Order</button>
                  </td>

                  <td style="cursor: pointer;" *ngIf="item.del==true">
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" style="margin-right: 5px;"
                      class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                    <p style="color: red" *ngIf="item.done==null">Deleted</p>
                    <p style="color: red" *ngIf="item.done==false">Assignment Cancelled</p>
                    <p style="color: green" *ngIf="item.done==true">Assignment Completed</p>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                </tr>

                <tr *ngIf="item.expert.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #396c9b; color: white;">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Last Name</th>
                          <th>National ID</th>
                          <th>Mobile Number</th>
                          <th>Father's Name</th>
                          <th>Supervisor</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.expert">
                          <td>{{item.expert.indexOf(detail)+1}}</td>
                          <td>{{detail.name}}</td>
                          <td>{{detail.familly}}</td>
                          <td>{{detail.melicode}}</td>
                          <td>{{detail.shomareh_Hamreh}}</td>
                          <td>{{detail.name_Pedar}}</td>
                          <td>
                            <p *ngIf="detail.seleted">Yes</p>
                            <p *ngIf="!detail.seleted">No</p>
                          </td>
                          <td *ngIf="canEditPlannigForm" style="cursor: pointer;">

                            <a *ngIf="!detail.seleted && detail.del==false" style="cursor: pointer;"
                              (click)="Change_Seleted_ExpertCalibration_Record(item,item.expert.indexOf(detail))"
                              class="dropdown-item"><i class="fa fa-check"></i> Supervisor </a>

                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="ExpertCalibration_Delete(item.expert.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>

                            <p *ngIf="detail.del==true">Deleted</p>
                            <i *ngIf="detail.sms" class="fa fa-envelope" style="color: blue;"></i>
                          </td>
                          <td *ngIf="!canEditPlannigForm" style="cursor: pointer;">

                            <a style="cursor: pointer;"
                              *ngIf="detail.del==false && detail.visible==true && canDownloadPDFPlaning"
                              (click)="ExpertCalibration_Visible(detail)" class="dropdown-item"><i
                                class="fa fa-eye"></i> View </a>

                            <a style="cursor: pointer;"
                              *ngIf="detail.del==false && detail.visible==false && canDownloadPDFPlaning"
                              (click)="ExpertCalibration_Visible(detail)" class="dropdown-item"><i
                                class="fa fa-eye-slash"></i> Hide </a>


                            <p *ngIf="detail.del==true">Deleted</p>
                            <i *ngIf="detail.sms" class="fa fa-envelope" style="color: blue;"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

                <tr *ngIf="item.deviceBehfa.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #9b5539; color: white;">
                        <tr>
                          <th>#</th>
                          <th>System ID</th>
                          <th>Description</th>
                          <th>Manufacturer</th>
                          <th>Model</th>
                          <th>Code BEHFA</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.deviceBehfa">
                          <td>{{item.deviceBehfa.indexOf(detail)+1}}</td>
                          <td>{{detail.code}}</td>
                          <td class="EnglishClm">{{detail.description}}</td>
                          <td class="EnglishClm">{{detail.manufacturer}}</td>
                          <td class="EnglishClm">{{detail.model}}</td>
                          <td class="EnglishClm">{{detail.codeBEHFA}}</td>
                          <td *ngIf="canEditPlannigForm" style="cursor: pointer;">
                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="DeviceBehfa_Delete(item.deviceBehfa.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>

                            <p *ngIf="detail.del==true">Deleted</p>
                          </td>
                          <td *ngIf="!canEditPlannigForm" style="cursor: pointer;">
                            <p *ngIf="detail.del==true">Deleted</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

              </ng-container>
            </tbody>
          </table>




        </div>

        <br />
        <br />


        <div>

          <h5> Schedule Letter Messages </h5>

          <br />

          <form *ngIf="canEditPlannigForm" [formGroup]="MailMessageForm_Schedule"
            (submit)="MailMessageForm_Schedule_Submit()">

            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> Letter Message </label>
                <select class="custom-select" formControlName="mailmessage_id">
                  <option value="0">Select</option>
                  <option *ngFor="let item of DataList_MailMessage_Schedule" [value]="item.id">{{item.title}}</option>
                </select>
              </div>
            </div>

            <button type="submit" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i>
              Add Message </button>

          </form>




          <br />
          <br />

          <div class="table-responsive" *ngIf="FormAdded_MailMessage_Schedule.length>0">


            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>Letter Message</th>
                  <th *ngIf="canEditPlannigForm">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of FormAdded_MailMessage_Schedule" [ngClass]="{'ModirEdit': item.del==true}">
                  <td>{{FormAdded_MailMessage_Schedule.indexOf(item)+1}}</td>
                  <td>{{item.title}}</td>
                  <td style="cursor: pointer;" *ngIf="canEditPlannigForm">
                    <a style="cursor: pointer;"
                      (click)="MailMessageForm_Schedule_Delete(FormAdded_MailMessage_Schedule.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </td>
                </tr>
              </tbody>
            </table>




          </div>

          <br />
          <br />

        </div>

      </div>

    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing " type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="!AddNewLetter.valid" [class]="item.cls" style="margin-right: 5px;"> <i [class]="item.icon"></i>
          {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"><i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
      </ng-container>

      <button type="button" *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="openModal_Karshans(templateKarshans)"
        class="btn btn-info left" style="margin-right: 5px;"> <i class="fa fa-mobile-phone"></i> Calibration Representative
      </button>

      <button *ngIf="has_calibration_customer_order && !InProccessing" type="button" class="btn btn-info"
        style="margin-right: 5px;">
        <i class="fa fa-info-circle"></i> Additional Services Request
      </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-right: 5px;"> <i class="fa fa-file-text"></i> Letter Details </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="OpenNoteDialog(templateComment)" type="button"
        class="btn btn-success" style="margin-right: 5px;"> <i class=" fa fa-sticky-note-o"></i> Submit Comment </button>

      <a target="_blank" *ngIf="canDownloadPDF && !InProccessing" href="{{BaseUrl}}{{Letter_Form_Id}}"
        style="margin-right: 5px;" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> Preview </a>

      <a target="_blank" style="margin-right: 5px;" *ngIf="canDownloadPDFPlaning && !InProccessing"
        href="{{BaseUrl1}}{{Letter_Form_Id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> Schedule Notification Letter
      </a>

      <button *ngIf="canFillReviewForm && !InProccessing" (click)="Show_Review_View()" type="button"
        class="btn btn-danger" style="margin-right: 5px;"> <i class="fa fa-leanpub"></i> Revision</button>
    </div>

    <br />
    <br />



  </div>
</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Letter Details '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Referral History</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">Letter Attachments</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">Referral Workflow</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Latest
            Referral</button>
        </div>

        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="DataList_Peyvast">

            </app-LetterRequestCustomerPeyvast>

          </div>
        </div>

        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>

</div>

<div *ngIf="Show_History_View==2" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0"> Assignment Order '{{Selected_LetterRequestCustomer_Schedule.id}}' on
            <span style="display: inline-block;">{{Selected_LetterRequestCustomer_Schedule.persianDate}}</span> from
            {{Selected_LetterRequestCustomer_Schedule.startDate}} to {{Selected_LetterRequestCustomer_Schedule.endDate}}
          </h5>
          <h5 class="card-title border-0 pb-0"> Letter Number '{{Letter_Form_Code}}'</h5>

        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Event Registration Form</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">Registered Events</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">Instruments</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#form" role="tab" aria-controls="months"
                aria-selected="true">Assignment Order Form</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#karshnas" role="tab"
                aria-controls="months" aria-selected="true">Calibration Representative </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivity [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivity>
            </div>



          </div>

        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityList
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivityList>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityDevice
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id">

              </app-LetterRequestCustomerMissionActivityDevice>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="form" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityForm
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivityForm>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="karshnas" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-CutomerKarshnas [inner_Customer]="Data_Seleted_Customer.id">

              </app-CutomerKarshnas>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
    <a target="_blank" href="{{BaseUrl3}}{{Selected_LetterRequestCustomer_Schedule.id}}" style="margin-right: 5px;"
      class="btn btn-info"><i class="fa fa-file-pdf-o"></i> PDF</a>
  </div>
</div>

<div *ngIf="Show_History_View==3" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="row mb-30">
      <div class="form-group col-md-12">
        <h5 class="card-title border-0 pb-0">Letter Review Form '{{Letter_Form_Code}}'</h5>
        <app-LetterRequestCustomerReviewAnswer [inner_Letter_id]="Letter_Form_Id">

        </app-LetterRequestCustomerReviewAnswer>
      </div>

    </div>
  </div>

  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>

  </div>
</div>


<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Behfa Customer Code</th>
              <th>Customer Name</th>
              <th>Customer Name (English)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td>{{item.name_en}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCustomerAddress>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer Address List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CustomerAdress.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Address Title</th>
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Address">
              <td>{{DataList_Address.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.address}}</td>
              <td (click)="Set_Data_Seleted_Address(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Initial_Customer()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CustomerAdress.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Calibration Technician List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Instrument Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Instrument Name </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | paginate
                    : {
                        id: 'DataList_Device',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Letter Number </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Letter Number <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-body" *ngIf="canShowSendSMS">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Position</th>
            <th>Mobile Number</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">Mr.</span>
              <span *ngIf="item.sex==0">Ms.</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" *ngIf="!item.del" class="btn btn-danger"
                (click)="Change_Selected_Of_Karshnash(item)">Deselect</button>
              <button type="button" *ngIf="item.del" class="btn btn-info" (click)="Change_Selected_Of_Karshnash(item)">
                Select</button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

    <button type="button" *ngIf="canShowSendSMS" class="btn btn-success" (click)="SendSMS()">Send SMS</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateKarshans>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Mobile Number Calibration Representative </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Karshans.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Position</th>
            <th>Mobile Number</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">Mr.</span>
              <span *ngIf="item.sex==0">Ms.</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Karshans.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Letter Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Subject </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Letter Type</th>
              <th>Customer Name</th>
              <th>Letter Subject </th>
              <th>Recipient Name</th>
              <th>Recipient Position</th>
              <th>Sender User</th>
              <th>Recipient User</th>
              <th>Status</th>
              <th>Message</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomerCopy>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Copy Outgoing Letter</h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="modalRef_LetterRequestCustomerCopy.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomerCopy"
            placeholder="Type here to search...">
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomerCopy" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="Copy_LetterRequestCustomer()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomerCopy.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">Recipient</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">Select</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,templateLetterTarrifFloor,Selected_Order_Operation)"> Submit and Register
    </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRequest90>
  <div class="modal-header">
    <h4 *ngIf="statusFunction==1" class="modal-title pull-left"> Approve Schedule Information </h4>
    <h4 *ngIf="statusFunction==2" class="modal-title pull-left">Reject Schedule Information </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Request90.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="statusFunction==1" type="button" class="btn btn-warning" (click)="ChangeStatus_Request90()"> Approve
      Information <i class="fa fa-check"></i></button>
    <button *ngIf="statusFunction==2" type="button" class="btn btn-warning" (click)="ChangeStatus_Request90()"> Reject
      Information <i class="fa fa-times-circle"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Request90.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Submit a New Customer Comment for Customer '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]="Proccessing_Schedule.persianDate"
      [inner_SeletedDeviceBehfa]="this.Proccessing_Schedule.deviceBehfa"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event,templateDeviceBehfaSchedule)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Approve Delete Instrument '{{DeleteDeviceFormList_Record.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> Delete Instrument <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateDeviceBehfaSchedule>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Warning </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,0)">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngFor="let item of DataList_DeviceBehfa_Schedule">{{item.replace('-','/')}}</p>
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,1)">Approve and Add</button>
    <button type="button" class="btn btn-danger"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,1)">Cancel</button>
  </div>
</ng-template>

<ng-template #templateLetterTarrifFloor>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirm Operation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_TarrifFloor.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">

        <span>
          {{TarrifFloorDsc}}
        </span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="LetterTarrifFloor()"> Confirm Completion </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterTarrifFloor.hide()">Close</button>
  </div>
</ng-template>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Instrument Name</th>
      <th>Calibration Location</th>
      <th>Count</th>
      <th>Validity Period</th>
      <th>Manager Adjustment (IRR)</th>
      <th>Unit Amount (IRR)</th>
      <th>Total (IRR)</th>
      <th>Remarks</th>
      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DeviceFormList">
      <td>{{DeviceFormList.indexOf(item)+1}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.location_name === 'محل مشتری' ? 'Customer Site' : item.location_name === 'آزمایشگاه بهینه' ? 'Behineh Laboratory' : item.location_name}}</td>
      <td>{{item.tedad}}</td>
      <td>{{item.expiration_title}}</td>
      <td>{{item.incRailModir|number}}</td>
      <td>{{item.price|number}}</td>
      <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
      <td>{{item.price_dsc}}</td>
      <td>{{item.dscUser}}</td>
    </tr>

  </tbody>

</table>
